<template>
    <div id="app" ref="r_app">
        <!--<keep-alive>-->
            <router-view></router-view>
        <!--</keep-alive>-->
    </div>
</template>

<script>
export default {
    name: 'App',
    components: {},
    mounted: function () {
        let self = this
        self.$nextTick(function () {
            document.getElementById("loads").style.display = "none"
        })
    }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 13px;
  color: #2c3e50;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue